<template>
  <div class="container">
  <div class="footer">
    <div class="col-left">
      <div class="margin-top"></div>
      <div>
        <span class="cadastrar" @click="$store.state.usuario.usuario == null ? login() : minhaConta()">
          <button type="submit" class="bt-login">
            {{$store.state.usuario.usuario == null ? 'Faça login ou cadastre-se': 'Acesse sua conta'}}
          </button>
        </span>
      </div>
      <div class="creditos">
        <p>@2020 Espírito Santo - Brasil</p>
        <p>Todos os direitos reservados</p>
      </div>

      <!--
      <p class="titulo-footer-peq margin-top">INSTALE NOSSO APP</p>
      <div class="icones margin-top">
        <a href="#" target="_blank" title="ANDROID Play Store">
          <i class="fab fa-google-play icone-svg"></i>
        </a>
        <a href="#" target="_blank" title="APPLE Store">
          <i class="fab fa-apple icone-svg"></i>
        </a>
      </div>
      -->
    </div>

    <div class="col-center">
        <img src="https://firebasestorage.googleapis.com/v0/b/loja-ilha-teste.appspot.com/o/assets%2Ffoto_rodape.webp?alt=media&token=a3da247a-abe4-48af-a606-a9142cd50e27" />
    </div>

    <div class="col-right">
      <div class="icones margin-top">
        <a href="https://pt-br.facebook.com/ilhadocaranguejo/" target="_blank" title="Facebook Ilha do Caranguejo">
          <i class="fab fa-facebook-square icone-svg"></i>
        </a>
        <!--
        <a href="#" target="_blank" title="Youtube Ilha do Caranguejo">
          <i class="fab fa-youtube icone-svg"></i>
        </a>
        -->
        <a href="https://www.instagram.com/ilhadocaranguejo/?hl=pt-br" target="_blank" title="Instagram Ilha do Caranguejo">
          <i class="fab fa-instagram-square icone-svg"></i>
        </a>
      </div>
      <div>
        <p class="titulo-footer-peq">CONTATOS</p>
        <p>ilha@ilha.es</p>
        <p class="telefones">
          VITÓRIA (27) 3395-0244<br>
          VILA VELHA (27) 2233-8484<br>
        </p>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    minhaConta () {
      this.$router.push({name: 'Minha Conta'})
    },
    login () {
      this.$router.push({name: 'Login'})
    }
  }
}
</script>

<style scoped>
  .container {
    grid-area: header;
    width: 100%;
    margin-top: 100px;
  }
  .footer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: space-between;
    justify-items: center;
    align-items: start;
    max-width: 1174px;
    margin: 0 auto 40px auto;
    flex-wrap: wrap;
    width: 100%;
    padding: 8px 0;
    gap: 50px;
  }

@media (max-width: 1170px) {
  .footer {
    grid-template-columns: 1fr 1fr;
    justify-content: space-around;
    gap: 5px;
  }
  .col-center {
    display: none;
  }
  .container {
    width: 100%;
    margin-top: 40px;
  }
}

@media (max-width: 760px) {
  .footer {
    grid-template-columns: 1fr;
    justify-content: center;
  }
}

  .col-center img {
    margin: 0 auto;
  }

  .col-right, .col-left {
    border-top: 2px solid #2E9189;
    min-width: 358px;
    margin-top: 40px;
    color: #2E9189;
  }

  .margin-top {
    margin-top: 30px;
  }

  .icones a {
    margin: 0 12px 0 12px;
    color: #2E9189;
  }

  .icones a:hover {
    color: #F85E28;
  }

  .icone-svg {
    width: 30px;
    height: 30px;
  }

  .col-right p {
    margin: 15px 0;
    line-height: 1.5;
  }

  .titulo-footer-peq {
    font-size: 0.8em;
    font-weight: 600;
  }

  .telefones {
    font-size: 1.2em;
    font-weight: 500;
  }

  .creditos {
    margin: 40px 0;
    font-size: 0.9em;
  }

  .creditos p {
    margin: 5px 0;
  }

  button {
    color: #fff;
    padding: 10px 20px;
    border-radius: 4px;
    border: 0;
    font-size: 1.05em;
    cursor: pointer;
    box-shadow: 0 4px 8px rgba(30, 60, 90, 0.2);
    transition: all 0.3s;
  }

  button:hover {
    transform: scale(1.1);
  }

  .bt-login {
    background: #2E9189;
  }

  .bt-login:hover {
    background: #186B65;
    transform: scale(1.1);
  }

  .cadastrar {
    display: block;
    padding: 10px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue